import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'cs-name-badge',
  standalone: false,
  templateUrl: './name-badge.component.html',
  styleUrls: ['./name-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class NameBadgeComponent {
  @HostBinding('class.cs-badge')
  public tr = true;
  @HostBinding('class.cs-chip')
  @Input()
  public chip = false;
  @Input()
  public value: string;

  @HostBinding('style.backgroundColor')
  public get updateColor(): string {
    if (this.chip) {
      return '#f0f4f7';
    } else {
      const char = this.value?.toUpperCase().trim()[0];
      if (/[A-E]/.test(char)) {
        return '#004c1a';
      }
      if (/[F-J]/.test(char)) {
        return '#aa0000';
      }
      if (/[K-O]/.test(char)) {
        return '#b600a0';
      }
      if (/[P-T]/.test(char)) {
        return '#5c2893';
      }
      if (/[U-Y]/.test(char)) {
        return '#008272';
      }
      if (/Z/.test(char)) {
        return '#6dc4f1';
      }
      return '#f0f4f7';
    }
  }
}
